// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1432":"2df02ffa5ef648cb","3575":"1f092e862c36d134","5374":"4b3fdf0c5e1a70a5"}[chunkId] + ".js";
};